import {
    audioExtensionsStr,
    cellExtensionsStr, compressedExtensionsStr,
    docExtensionsStr,
    imageExtensionsStr, otherExtensionStr,
    slideExtensionsStr, threeDExtensionStr,
    videoExtensionsStr
} from "./Common";

export function isAllowedUpload(extension) {

    return isOpenFile(extension) || is3dFile(extension) || isOtherFile(extension) || isCompressedFile(extension)
}
export function isOpenFile(extension) {

    return isAudioFile(extension) ||
        isImageFile(extension) ||
        isVideoFile(extension) ||
        isOfficeFile(extension)
}

export function isOfficeFile(extension) {

    return isWordFile(extension) ||
        isCellFile(extension) ||
        isSlideFile(extension)
}

export function is3dFile(extension) {

    return isFile(extension, threeDExtensionStr)
}

export function isOtherFile(extension) {

    return isFile(extension, otherExtensionStr)
}

export function isCompressedFile(extension) {

    return isFile(extension, compressedExtensionsStr)
}

export function isAudioFile(extension) {

    return isFile(extension, audioExtensionsStr)
}

export function isVideoFile(extension) {

    return isFile(extension, videoExtensionsStr)
}

export function isImageFile(extension) {

    return isFile(extension, imageExtensionsStr)
}

export function isWordFile(extension) {

    return isFile(extension, docExtensionsStr)
}

export function isCellFile(extension) {

    return isFile(extension, cellExtensionsStr)
}

export function isSlideFile(extension) {

    return isFile(extension, slideExtensionsStr)
}

export function isFile(extension, extensionStr) {
    if (!extension) return !!extension
    return extensionStr.indexOf(extension) !== -1
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getFileExtension(name) {

    return name.split('.').pop();
}